/* CARD HOVER VIDEO — the clip plays while the cursor is on the card.

   WHY. The PDP work put the try-on clip at slide 2 on ~50 products, and slide 2 is
   exactly what a Dawn card shows on hover. `image_url` on a video returns its
   POSTER, so every one of those cards hovered to a single frozen frame. Tracy
   2026-09-23: "when you hover, the second image is the video … but those videos are
   not auto-playing in hover. They're weird stuck images."

   WHY NOT the `autoplay` attribute. A collection page carries 28-34 cards; letting
   the browser autoplay every clip would fetch tens of megabytes for video nobody is
   looking at. The markup ships `preload="none"` and nothing is requested until the
   pointer actually lands on a card — so an untouched card costs zero bytes beyond
   its poster.

   Desktop only, by construction: the CSS hides .cnc-card-video under
   `@media (hover: none)`, so a phone never reveals it and never downloads it. This
   file also gates on matchMedia('(hover: hover)') so no listeners are attached
   there either.

   The rewind rule matches cnc-pdp-gallery-video.js deliberately — a clip that has
   genuinely been left restarts, a cursor wobble does not. Two surfaces, one
   behaviour. */
(function () {
  function init() {
    var vids = document.querySelectorAll('.cnc-card-video');
    if (!vids.length) return;

    /* No hover (touch, most phones): the CSS already hides these. Attaching
       pointer listeners as well would only cost work for no visible effect. */
    if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

    /* Someone who asked for less motion gets the poster, which is what a video
       that is never played already shows. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Data saver / 2G: the poster is kinder than a clip fetched on a hover the
       visitor may not have meant. */
    var conn = navigator.connection || {};
    if (conn.saveData || (conn.effectiveType && /(^|-)2g$/.test(conn.effectiveType))) return;

    Array.prototype.forEach.call(vids, function (v) {
      var card = v.closest('.card-wrapper') || v.closest('.card');
      if (!card || card.dataset.cncHoverWired === '1') return;
      card.dataset.cncHoverWired = '1';

      card.addEventListener('mouseenter', function () {
        /* preload="none" means there is nothing buffered until now. load() starts
           the fetch; play() resolves once enough has arrived. */
        if (v.readyState === 0) v.load();
        if (v.paused && v.currentTime > 0.3) v.currentTime = 0;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        if (!v.paused) v.pause();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The grid re-renders on filter/sort and on paginated loads, which replaces the
     cards wholesale — re-wire whatever came back. */
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
